import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a5282f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "workout-record"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-trophy",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

import { toRefs } from 'vue'

  import { IWorkoutObject } from '@/types/workouts'

  interface Props {
    recordType: string
    workoutObject: IWorkoutObject
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    recordType: null,
    workoutObject: null
  },
  setup(__props: any) {

const props = __props as {
    recordType: string
    workoutObject: IWorkoutObject
  }

  

  const { recordType, workoutObject } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (
      _unref(workoutObject).records &&
      _unref(workoutObject).records.find((record) => record.record_type === _unref(recordType))
    )
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _hoisted_3))
    : _createCommentVNode("", true)
}
}

})